import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { LoadOptions } from 'devextreme/data';
import CustomStore from 'devextreme/data/custom_store';
import DxDataGrid from 'devextreme/ui/data_grid';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { GraphqlService } from 'src/app/graphql/graphql.service';
import { Enterprise } from 'src/app/shared/models';

@Component({
	selector: 'pk-broker-enterprise-selector-modal',
	templateUrl: './enterprise-selector-modal.component.html',
	standalone: false,
})
export class EnterpriseSelectorModalComponent implements OnInit, AfterViewChecked {
	public onSubmit: Subject<Enterprise> = new Subject();

	public searchForm: FormGroup;
	public enterprises: Enterprise[] = [];
	public enterprisesTotal: number;
	public enterprisesDataSource: any = {};
	private dataGrid: DxDataGrid;

	constructor(
		private activeModal: BsModalRef,
		private graphqlService: GraphqlService,
		private fb: FormBuilder,
	) {}

	ngOnInit(): void {
		this.searchForm = this.fb.group({
			criteria: '',
		});
		this.enterpriseDataSourceInit();
	}

	ngAfterViewChecked(): void {
		const emptyRows = document.getElementsByClassName('dx-freespace-row');
		Array.from(emptyRows).forEach(node => node.remove());
	}

	private async enterpriseDataSourceInit() {
		this.enterprisesDataSource.store = new CustomStore({
			key: 'id',
			load: async (loadOptions: LoadOptions) => {
				if (loadOptions['dataField']) {
					return Promise.resolve({
						data: this.enterprises,
						totalCount: this.enterprisesTotal,
					});
				}

				const criteria: any = {};
				const search = this.searchForm?.get('criteria')?.value;
				if (search) {
					criteria.search = `%${search}%`;
				}

				const enterpriseResponse = await this.graphqlService.getEnterpriseListData(criteria, 'name', loadOptions.take, loadOptions.skip);
				this.enterprises = enterpriseResponse.data.enterprises.message.map(e => new Enterprise(e));
				this.enterprisesTotal = enterpriseResponse.data.enterprises.total;

				return {
					data: this.enterprises,
					totalCount: this.enterprisesTotal,
				};
			},
		});
	}

	public onDataGridInit(event: any): void {
		this.dataGrid = event.component;
	}

	public onSearch(): void {
		if (!this.dataGrid) {
			return;
		}
		const state = this.dataGrid.state();
		this.dataGrid.state(state);
	}

	public close(): void {
		this.activeModal.hide();
	}

	public selectEnterprise(enterprise: Enterprise): void {
		this.onSubmit.next(enterprise);
		this.activeModal.hide();
	}
}
